
import { Component, Mixins } from 'vue-property-decorator';
import { isVisibleLineBanner } from '@/lib/functions';
import store from '@/store';
import SidenaviLine from './';
const Words: Dictionary = {
  label: 'LINEアプリで友だち追加する',
};
@Component
export default class SidenaviLineJa extends Mixins(SidenaviLine) {
  private words = Words;

  get isGroup(): boolean {
    return this.$store.getters['auth/group'];
  }

  get visibleLineBanner(): boolean {
    return isVisibleLineBanner({
      lang: store.getters['auth/lang'],
      group: store.getters['auth/group'],
      isLineLogin: store.getters['auth/line'],
    });
  }
}
